import axios from 'axios';
import { toast } from 'sonner';

const UNDO_MS = 8000;

// Shows "Factura eliminada" with a Deshacer action; restores via POST /api/invoices/{id}/restore.
export const toastDeletedWithUndo = ({ invoiceId, label, headers, onRestored }) => {
    toast.success(`Factura eliminada${label ? `: ${label}` : ''}`, {
        id: `deleted-${invoiceId}`,
        duration: UNDO_MS,
        description: 'Puedes recuperarla durante unos segundos.',
        action: {
            label: 'Deshacer',
            onClick: async () => {
                try {
                    const res = await axios.post(`/api/invoices/${invoiceId}/restore`, {}, { headers });
                    toast.success('Factura recuperada');
                    onRestored?.(res.data.invoice);
                } catch (e) {
                    toast.error(e.response?.data?.detail || 'No se pudo recuperar la factura');
                }
            },
        },
    });
};
